package kz.dentalcrm.app.screens.appointments.mvi.models

import kz.dentalcrm.app.data.network.response_model.AppointmentResponse

data class UIAppointment(
    val data: AppointmentResponse,
    val millis: Long = 0,
    val time: String,
)
